angular
  .module('surfsightApp.controllers')
  .controller('multipleBroadcastVideosCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$stateParams',
    '$timeout',
    '$interval',
    '$location',
    '$window',
    '$http',
    '$filter',
    '$localStorage',
    '$mdDialog',
    '$mdSidenav',
    '$mdToast',
    '$mdColors',
    '$mdMedia',
    'edgeFactoryV2',
    'edgeGroupFactory',
    'broadcastViewFactory',
    'leafletData',
    'leafletBoundsHelpers',
    'nominatimLookUp',
    function (
      $scope,
      $rootScope,
      $state,
      $stateParams,
      $timeout,
      $interval,
      $location,
      $window,
      $http,
      $filter,
      $localStorage,
      $mdDialog,
      $mdSidenav,
      $mdToast,
      $mdColors,
      $mdMedia,
      edgeFactoryV2,
      edgeGroupFactory,
      broadcastViewFactory,
      leafletData,
      leafletBoundsHelpers,
      nominatimLookUp
    ) {
      /**
       * dashcamStream: {
       * 	serialNumber,
       * 	streamId,
       * 	cameraName
       * }
       */
      $scope.dashcamStreams = []
      const $translate = $filter('translate')
      $scope.userToken = $localStorage.userToken
      $scope.currentUserOrganizationId =
        $localStorage.currentUserOrganization.id
      $scope.currentState = $state.current.name
      $scope.multipleEventsVideos = []
      $scope.eventRecordingsPlayers = []
      $scope.recordingVideos = []
      $scope.videosListScrollbarOptions = {
        enable: $mdMedia('gt-sm'),
        autoHide: false
      }
      let eventsCount = 0
      $scope.dashcamStreamsAdded = function (
        dashcamStreams,
        open_sidepanel = false
      ) {
        dashcamStreams.forEach(dashcamStream => {
          let mediaToken = $localStorage.userMediaAccessToken // need to remove this
          dashcamStream.mediaToken = mediaToken
          let found = $scope.dashcamStreams.some(
            d =>
              d.serialNumber === dashcamStream.serialNumber &&
              d.streamId === dashcamStream.streamId
          )

          !found && $scope.dashcamStreams.push(dashcamStream)
        })
      }
      $scope.$on('dashcamStreamsAdded', function (e, data) {
        var dashcamStreams = data.data.dashcamStreams
        $scope.dashcamStreamsAdded(dashcamStreams)
      })
      $scope.$on(
        'broadcastViewReceive',
        (e, { broadcastViewData, broadcastViewId }) => {
          $scope.dashcamStreams = []
          const dashcamStreams = broadcastViewData
          dashcamStreams.forEach(
            ({ cameraName, serialNumber, ...dashcamStream }, index) => {
              if (!cameraName) {
                edgeFactoryV2.list.forEach(({ imei, name }) => {
                  if (serialNumber === imei) {
                    cameraName = name
                  }
                })
              }
              dashcamStreams[index] = {
                cameraName,
                serialNumber,
                ...dashcamStream
              }
            }
          )
          $scope.broadcastViewId = broadcastViewId
          $scope.dashcamStreamsAdded(dashcamStreams)
        }
      )
      $scope.dashcamStreamCallback = event => {
        if (event.type === 'shareDashcamLiveVideo') {
          shareDashcamLiveVideo(event.dashcamStream)
        } else if (event.type === 'closeDashcamLiveVideo') {
          closeDashcamLiveVideo(event.dashcamStream)
        }
      }

      $scope.closeDashcamLytxLiveVideo = (event, dashcamStream) => {
        console.log(event)
        closeDashcamLiveVideo(dashcamStream)
      }
      $scope.componentErrorLytxLiveVideo = event => {
        console.log(event)
      }

      const closeDashcamLiveVideo = dashcamStream => {
        if (dashcamStream) {
          let dashcamStreamIndex = $scope.dashcamStreams.findIndex(
            d =>
              d.serialNumber === dashcamStream.serialNumber &&
              d.streamId === dashcamStream.streamId
          )
          dashcamStreamIndex > -1 &&
            $scope.dashcamStreams.splice(dashcamStreamIndex, 1)
        } else {
          $scope.dashcamStreams = []
        }
        verifyAllPlayers()
      }

      $scope.$on('closeAllBroadcasts', function (e, data) {
        if ($scope.dashcamStreams.length > 0) {
          closeDashcamLiveVideo()
        }
      })
      const shareDashcamLiveVideo = dashcamStream => {
        if ($localStorage.userDetails.permission_role !== 'administrator') {
          $scope.showMessageToast(
            $translate(
              'youMustHaveAdministratorPrevilageInOrderToShareThisVideo'
            )
          )
          return
        }
        $mdDialog
          .show({
            locals: {
              dataFromCaller: {
                dashcamStream
              }
            },
            controller: 'EdgeShareBroadcastController',
            templateUrl:
              './templates/edge.share.broadcast.view.html?t=' +
              window.webpackHash,
            parent: angular.element(document.body),
            targetEvent: null,
            clickOutsideToClose: true,
            fullscreen: true // Only for -xs, -sm breakpoints.
          })
          .then(function (response) {
            $scope.showMessageToast(
              $translate('otuCreatedSuccessfully'),
              'selenium-success-otu-created'
            )
          })
          .catch(function (response) {})
      }
      $scope.dashcamStreamsCols = 1
      $scope.getBroadcastRowspan = function (broadcast) {
        let numberOfDashcamStreams = $scope.dashcamStreams.length
        let dashcamStreamsCols = 1
        if (numberOfDashcamStreams == 1) {
          dashcamStreamsCols = 1
        } else if (numberOfDashcamStreams >= 2 && numberOfDashcamStreams <= 5) {
          dashcamStreamsCols = 2
        } else if (numberOfDashcamStreams >= 6) {
          dashcamStreamsCols = 3
        }
        let rowspan = 1
        let maxRowspan = 1
        if ($mdMedia('gt-md') || $mdMedia('md')) {
          maxRowspan = 3
        } else if ($mdMedia('sm')) {
          maxRowspan = 2
        } else {
          maxRowspan = 1
          dashcamStreamsCols = 1
        }
        if (broadcast.fullScreen) {
          rowspan =
            dashcamStreamsCols < maxRowspan ? dashcamStreamsCols : maxRowspan
        }
        $scope.dashcamStreamsCols = dashcamStreamsCols
        return rowspan
      }
      $scope.$on('recordingVideoAddedEmit', (e, data) => {
        const { streamId, edge, nearestLocation, recordingStreamQuality } = data
        const serialNumber = edge.imei
        const mediaToken = $localStorage.userMediaAccessToken
        const found = $scope.recordingVideos.some(
          e => e.streamId === streamId && e.serialNumber === serialNumber
        )
        if (found) {
          return
        }
        const recordingVideo = {
          streamId,
          serialNumber,
          mediaToken,
          edge,
          nearestLocation,
          recordingStreamQuality
        }
        $scope.recordingVideos.push(recordingVideo)
      })
      $scope.closeRecordingVideo = recordingVideo => {
        if (recordingVideo) {
          let recordingVideoIndex = $scope.recordingVideos.findIndex(
            d =>
              d.serialNumber === recordingVideo.serialNumber &&
              d.streamId === recordingVideo.streamId
          )
          recordingVideoIndex > -1 &&
            $scope.recordingVideos.splice(recordingVideoIndex, 1)
        } else {
          $scope.recordingVideos = []
        }
        verifyAllPlayers()
      }

      if (
        [
          'home.common.edge.options',
          'home.common.edge.options.streams',
          'home.common.edge.options.cameras',
          'home.common.edge.options.settings',
          'home.common.edge.options.settings',
          'home.common.edge.options.settings.Maintenance'
        ].indexOf($scope.currentState) > 0
      ) {
        $timeout(function () {
          // $scope.openSideNav('edge-list');
          if ($mdMedia('gt-sm')) {
            $mdSidenav('multiple-braodcast-videos').open()
          }
        })
      }
      // $scope.openSideNav('multiple-braodcast-videos');
      // $mdSidenav('multiple-braodcast-videos').open();

      $scope.eventsVideoAdded = function (event, stream_id, edge) {
        // ~ $scope.multipleEventsVideos=;
      }

      $scope.closeEventVideo = id => {
        const index = $scope.multipleEventsVideos.findIndex(e => e.id === id)
        index > -1 && $scope.multipleEventsVideos.splice(index, 1)
        verifyAllPlayers()
      }
      $scope.removeEventRecordingPlayer = eventRecordingPlayer => {
        const index = $scope.eventRecordingsPlayers.findIndex(
          e =>
            e.device.imei === eventRecordingPlayer.device.imei &&
            e.event.id === eventRecordingPlayer.event.id
        )
        index > -1 && $scope.eventRecordingsPlayers.splice(index, 1)
        verifyAllPlayers()
      }

      $scope.closeBroadcastView = function () {
        $scope.broadcastViewId = 0
        $scope.$emit('closeBroadcastView', {})
      }
      $scope.closeMapBroadcastView = function () {
        $scope.broadcastViewId = 0
      }
      const verifyAllPlayers = () => {
        if (
          $scope.dashcamStreams.length === 0 &&
          $scope.multipleEventsVideos.length === 0 &&
          $scope.recordingVideos.length === 0 &&
          $scope.eventRecordingsPlayers.length === 0
        ) {
          $scope.closeBroadcastView()
          $scope.closeMapBroadcastView()
          $scope.$emit('mapSidenavOpenEvent', { mapSidenavOpen: false })
          if ($mdSidenav('map-multiple-braodcast-videos')) {
            $mdSidenav('map-multiple-braodcast-videos').close()
          }
          mapSidenavOpen = false
          if ($mdMedia('xs') || $mdMedia('sm')) {
            $mdSidenav('edge-list').open()
            $mdSidenav('edge-list').open()
          }
        }
      }

      $scope.ShowSaveBroadcastVideos = function (ev, dashcamStreams) {
        if (dashcamStreams.length == 0) {
          $scope.showMessageToast($translate('noBroadcastVideosAreFound'))
          return false
        } else {
          $mdDialog
            .show({
              locals: {
                broadcastsData: {
                  dashcamStreams: dashcamStreams
                },
                broadcastViewId: $scope.broadcastViewId
              },
              controller: 'EdgeBroadcastViewController',
              templateUrl:
                './templates/broadcast.videos.save.html?t=' +
                window.webpackHash,
              parent: angular.element(document.body),
              targetEvent: ev,
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
            })
            .then(
              function (response) {
                $scope.showMessageToast(response.data.status.error)
                if (!$scope.broadcastViewId) {
                  $scope.broadcastViewId = response.data.id
                  $scope.isNewBroadcastView = false
                }
                trackItem_BroadcastView($scope.broadcastViewId)
              },
              function () {
                //
              }
            )
        }
      }

      function trackItem_BroadcastView (broadcastView_id) {
        var request_json = {
          method: 'GET',
          url: BROADCAST_BASEURL + '/broadcastView/' + broadcastView_id,
          data: {}
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              broadcastViewFactory.addOrUpdateItem(response.data.broadcastView)
            }
          },
          function (response) {
            handleServerError(response)
            $scope.showMessageToast(response.data.status.error)
          }
        )
      }

      $scope.showMessageToast = function (message, className = '') {
        var toast = $mdToast
          .simple()
          .toastClass(className)
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
              // alert('You clicked the \'UNDO\' action.');
            }
          })
          .catch(() => {})
      }

      /** *******************************Events Video Functions**********************************/
      $scope.showEventsVideos = (event, streamId, edge) => {
        const found = $scope.multipleEventsVideos.some(
          e => e.eventId === event.id && e.streamId === streamId
        )
        if (found) {
          return
        }
        const file = event.files.find(e => e.cameraId === streamId)
        const { fileId, fileType } = file

        // todo: use getDeviceEventFileLink from edgeFactoryV2
        $http({
          method: 'GET',
          url: `${V2_BASEURL}/devices/${edge.imei}/event-file-link`,
          params: {
            fileId: fileId,
            fileType: fileType,
            cameraId: streamId
          }
        })
          .then(response => {
            const found = $scope.multipleEventsVideos.some(
              e => e.eventId === event.id && e.streamId === streamId
            )
            if (found) {
              return
            }
            const eventVideo = {
              id: `${edge.id}-${streamId}-${fileId}`,
              streamId,
              cameraName: edge.name,
              eventSetting: event.edge_setting,
              title: window.getCameraNameByStreamId(
                $filter('translate'),
                edge,
                streamId
              ),
              fileUrl: response.data.data.url,
              fileType: fileType || 'video',
              displayOptions: {
                closeVideo: true,
                close: true
              }
            }
            $scope.multipleEventsVideos.push(eventVideo)
          })
          .catch(error => {
            if (error.status === 404) {
              $scope.showMessageToast('Video not found.')
              $scope.$emit('mapSidenavOpenEvent', { mapSidenavOpen: false })
              if ($scope.multipleEventsVideos.length === 0) {
                $mdSidenav('map-multiple-braodcast-videos').close()
              }
            } else {
              handleServerError(error)
            }
          })
      }
      /** *******************************Events Video Functions**********************************/
      $scope.mdMedia = function (q) {
        return $mdMedia(q)
      }
    }
  ])
